const AuthFormCard = ({ children }) => {
   return <div className="bg-white p-6 pb-12 rounded-2xl relative w-[90%] mx-auto md:w-[41%] lg:w-2/6">{children}</div>;
};

export { AuthFormCard };
